/* eslint-disable import/prefer-default-export */

export const DATE_RANGE_UPDATE = 'DATE_RANGE_UPDATE';
export const UPDATE_FILTER= 'UPDATE_FILTER';

